var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.params.type === "image")?_c('self-image'):(_vm.$route.params.type === "video")?_c('self-video'):(_vm.$route.params.type === "ko-don")?_c('self-kodon'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }